/* CONTACT FORM Popup script*/ 
$(document).ready(function() {
    var $popup = $('#contactForm');
    var $closeIcon = $('#closeForm_icon');
    
    // Show popup
    $('[data-toggle="modal"]').on('click', function(event) {
        event.preventDefault();
        openPopup();
    });

    // Close popup when close icon is clicked
    $closeIcon.on('click', function() {
        closePopup();
    });

    // Close popup when clicking outside of it
    $(document).on('click', function(event) {
      var popupContact = $(".contactForm-cr");
        if (!popupContact.is(event.target) && popupContact.has(event.target).length === 0 && !$(event.target).is('[data-toggle="modal"]')) {
            closePopup();
        }
    });

    function openPopup() {
        $popup.css('display', 'block').hide().fadeIn(500); // Set display block, hide initially, then fade in
        $('body').css('overflow', 'hidden'); // Prevent scrolling
    }

    function closePopup() {
        $popup.fadeOut(500, function() {
            $(this).css('display', 'none'); // Ensure the element is hidden after fade out
        });
        $('body').css('overflow', ''); // Restore scrolling
    }
});

/* Inquery Form popup inquery*/ 
$(document).ready(function() {
    var $inqPopup = $('#inqueryForm');
    var $incloseIcon = $('#closeinqForm_icon');
    
    // Show popup
    $('[data-toggle="inqModal"]').on('click', function(e) {
        e.preventDefault();
        openInqPopup();
    });

    // Close popup when close icon is clicked
    $incloseIcon.on('click', function() {
        closeInqPopup();
    });

    // Close popup when clicking outside of it
    $(document).on('click', function(e) {
       var popupInquery = $(".inqueryForm-cr");     
        if (!popupInquery.is(e.target) && popupInquery.has(e.target).length === 0 && !$(e.target).is('[data-toggle="inqModal"]')) {
            closeInqPopup();
        }
    });

    function openInqPopup() {
        $inqPopup.css('display', 'block').hide().fadeIn(500); // Set display block, hide initially, then fade in
        $('body').addClass("no_scroll"); // Prevent scrolling
    }

    function closeInqPopup() {
        $inqPopup.fadeOut(500, function() {
            $(this).css('display', 'none'); // Ensure the element is hidden after fade out
        });
         $('body').removeClass("no_scroll"); // Restore scrolling
    }

     $(document).on('click', function(event) {
     
      var popupComp = $(".toast_msg_popup_inner");
        if (!popupComp.is(event.target) && popupComp.has(event.target).length === 0 ) {
           $(".tps_pendantbuilder_toast_msg_popup_wrapper").removeClass("tps_popoup_show");
        }
    });
});

/* Inquery Form popup inquery*/ 
$(document).ready(function() {
    var $noninqPopup = $('#non_bindingInqueryForm');
    var $nonincloseIcon = $('#closenoninqForm_icon');
    
    // Show popup
    $('[data-toggle="noninqModal"]').on('click', function(e) {
        e.preventDefault();
        openInqPopup();
        let price = getProData();
        if (price !== null) {
        $('.product_price .pro_price').text(price);
        $('#form_price').val(price);
      }
    });

    // Close popup when close icon is clicked
    $nonincloseIcon.on('click', function() {
        closeInqPopup();
    });

    // Close popup when clicking outside of it
    $(document).on('click', function(e) {
       var popupInquery = $(".non_bindingInqueryForm-cr");     
        if (!popupInquery.is(e.target) && popupInquery.has(e.target).length === 0 && !$(e.target).is('[data-toggle="noninqModal"]')) {
            closeInqPopup();
        }
    });
    function getProData() {
        let variantInput = document.querySelector('input[name="id"]');
        if (!variantInput) {
            console.log("Variant input field not found.");
            return null;
        }
    
        let selectedVariantId = variantInput.value;
        let selectedVariant = window.productVariants.find(variant => variant.id == selectedVariantId);
    
        if (selectedVariant) {           
             let formattedPrice = formatMoney(selectedVariant.price);
              //console.log("Formatted Price:", formattedPrice);
            return formattedPrice;
        } else {
            console.log("Variant not found.");
            return null;
        }
    }
    function openInqPopup() {
        $noninqPopup.css('display', 'block').hide().fadeIn(500); // Set display block, hide initially, then fade in
        $('body').addClass("no_scroll"); // Prevent scrolling
    }

    function closeInqPopup() {
        $noninqPopup.fadeOut(500, function() {
            $(this).css('display', 'none'); // Ensure the element is hidden after fade out
        });
         $('body').removeClass("no_scroll"); // Restore scrolling
    }

     $(document).on('click', function(event) {
     
      var popupComp = $(".toast_msg_popup_inner");
        if (!popupComp.is(event.target) && popupComp.has(event.target).length === 0 ) {
           $(".tps_pendantbuilder_toast_msg_popup_wrapper").removeClass("tps_popoup_show");
        }
    });
});
/* Dimond Inquery Form popup inquery*/ 
$(document).ready(function() {
    var $diainqPopup = $('#diamond_ingInqueryForm');
    var $diaincloseIcon = $('#closediainqForm_icon');
    
    // Show popup
    $('[data-toggle="diainqModal"]').on('click', function(e) {
        e.preventDefault();
        openInqPopup();
    });

    // Close popup when close icon is clicked
    $diaincloseIcon.on('click', function() {
        closeInqPopup();
    });

    // Close popup when clicking outside of it
    $(document).on('click', function(e) {
       var popupInquery = $(".diamond_InqueryForm-cr");     
        if (!popupInquery.is(e.target) && popupInquery.has(e.target).length === 0 && !$(e.target).is('[data-toggle="diainqModal"]')) {
            closeInqPopup();
        }
    });

    function openInqPopup() {
        $diainqPopup.css('display', 'block').hide().fadeIn(500); // Set display block, hide initially, then fade in
        $('body').addClass("no_scroll"); // Prevent scrolling
    }

    function closeInqPopup() {
        $diainqPopup.fadeOut(500, function() {
            $(this).css('display', 'none'); // Ensure the element is hidden after fade out
        });
         $('body').removeClass("no_scroll"); // Restore scrolling
    }

     $(document).on('click', function(event) {
     
      var popupComp = $(".toast_msg_popup_inner");
        if (!popupComp.is(event.target) && popupComp.has(event.target).length === 0 ) {
           $(".tps_pendantbuilder_toast_msg_popup_wrapper").removeClass("tps_popoup_show");
        }
    });
});

